import React, { useRef } from 'react';
import { DialogTitle, DialogContent, IconButton } from '@mui/material';
import * as MuiIcons from '@mui/icons-material';

const TicDialog = ({
  title,
  onComplete,
  children,
}: {
  title: string;
  onComplete(): void;
  children: JSX.Element;
}) => {
  const contentRef = useRef();

  return (
    <>
      <DialogTitle>
        {title}
        <IconButton
          onClick={onComplete}
          data-testid="close-button"
          size="large"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            // color: (theme) => theme.palette.grey[500],
          }}
        >
          <MuiIcons.Close />
        </IconButton>
      </DialogTitle>
      <DialogContent ref={contentRef} dividers>
        {children}
      </DialogContent>
      {/* <DialogActions></DialogActions> */}
    </>
  );
};

export default TicDialog;
